import compose from 'lyjs/es/fp/compose'
import { withRouter } from 'react-router-dom'
import withQuery from 'lyjs/es/components/withQuery'
import Authorization from './Authorization'
export default compose(
  withRouter,
  withQuery()
)(Authorization)
